import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import warning from "@/assets/myaccount/warning.svg";


interface SessionOutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  handleDelete: () => void; // No need for optional fid here
  type: string; // optional, remove if not used
}

const SessionOutDialog: React.FC<SessionOutDialogProps> = ({
  open,
  onOpenChange,
//   handleDelete,
}) => {
      // const navigate = useNavigate();
      //   const dispatch = useDispatch<AppDispatch>();
          // const { setLoading } = useLoading();

const handleLoginAgain = () => {
  // setLoading(true);
     onOpenChange(false); 
  // dispatch(logoutUser()).then(() => {
           
  //   navigate("/auth");           
  //   window.location.reload();     
  // }).finally(() => {
  //   setLoading(false);
  // });
};

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
      onInteractOutside={(e) => e.preventDefault()}
  onEscapeKeyDown={(e) => e.preventDefault()}


       hideCloseButton className="w-[30%] max-w-[900px] p-0 flex flex-col rounded-xl overflow-hidden bg-white">
        <DialogHeader className="bg-[#f4f4f4] text-[#181818] text-[22px] px-6 py-4">
          <DialogTitle>Session Expired</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="flex flex-col items-center justify-center text-center px-6 py-4 space-y-4">
            <img src={warning} alt="Warning" className="w-20 h-20" />
            <p className="text-[#363636] text-[16px] leading-[24px]">
              Your session has expired.
              <br />
              Please log in again to continue.
            </p>
          </div>
        </DialogDescription>

    <DialogFooter className="flex justify-center border-t border-gray-200 p-4">
      <Button
        className="px-6 h-[40px] bg-charcoal text-white rounded-md"
        variant="secondary"
        size="sm"
        onClick={handleLoginAgain}
      >
        Cancel
      </Button>
    </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SessionOutDialog;
